import { createContext, useContext, type ReactNode } from 'react';
import { CHAPTERS, type ChapterId, type ChapterMeta } from '@/lib/chapters';

// 章番号の唯一の供給源。ページ側が「その回のレポートで実際に出す章」の並びを渡し、
// 各章扉(ChapterSection)と章ナビ(ChapterNav)はこの並びの位置から番号を得る。
// 章の順序は lib/chapters.ts の CHAPTERS だけで決まり、各章コンポーネントは番号を持たない。
// 見通し章のようにデータ次第で出ない章があっても、番号が飛ばずに 1..N で詰まる。
const ChapterNumberingContext = createContext<readonly ChapterMeta[]>(CHAPTERS);

type ProviderProps = {
  chapters: readonly ChapterMeta[];
  children?: ReactNode;
};

export function ChapterNumberingProvider({ chapters, children }: ProviderProps) {
  return (
    <ChapterNumberingContext.Provider value={chapters}>
      {children}
    </ChapterNumberingContext.Provider>
  );
}

export type ChapterNumber = {
  /** 表示中の並びでの通し番号 (1 始まり)。並びに無い章は CHAPTERS 上の位置で代替する。 */
  num: number;
  /** 表示中の章数。 */
  total: number;
};

export function useChapterNumber(id: ChapterId): ChapterNumber {
  const visible = useContext(ChapterNumberingContext);
  const idx = visible.findIndex((c) => c.id === id);
  if (idx >= 0) return { num: idx + 1, total: visible.length };
  return { num: CHAPTERS.findIndex((c) => c.id === id) + 1, total: CHAPTERS.length };
}
